<aside class="sidebar" [class.open]="layoutService.sidebarOpen$ | async">
  <div class="sidebar-header">
    <img
      [src]="
        '/' +
        (themeService.getCurrentTheme() === 'dark'
          ? 'logo-dark.png'
          : 'logo.png')
      "
      alt="BarberPass"
      class="logo"
    />
  </div>
  <nav class="nav">
    <ul>
      <li>
        <a
          class="nav-link"
          routerLink="/home"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <i class="fas fa-home"></i>
          <span class="nav-text">Home</span>
        </a>
      </li>
      <li>
        <a class="nav-link" routerLink="/used-passes" routerLinkActive="active">
          <i class="fas fa-ticket-alt"></i>
          <span class="nav-text">Pass Utilizados</span>
        </a>
      </li>
      <li>
        <a class="nav-link" routerLink="/purchases" routerLinkActive="active">
          <i class="fas fa-shopping-cart"></i>
          <span class="nav-text">Compras</span>
        </a>
      </li>
      <li>
        <a
          class="nav-link"
          routerLink="/bulk-purchase"
          routerLinkActive="active"
        >
          <i class="fas fa-paper-plane"></i>
          <span class="nav-text">Comprar Pass</span>
        </a>
      </li>
      <li>
        <a
          class="nav-link"
          routerLink="/company-users"
          routerLinkActive="active"
        >
          <i class="fas fa-users"></i>
          <span class="nav-text">Usuários da Empresa</span>
        </a>
      </li>
      <li>
        <a
          class="nav-link"
          routerLink="/downloads"
          routerLinkActive="active"
        >
          <i class="fas fa-download"></i>
          <span class="nav-text">Downloads</span>
        </a>
      </li>
      <li>
        <a
          class="nav-link"
          routerLink="/reports"
          routerLinkActive="active"
        >
          <i class="fas fa-chart-bar"></i>
          <span class="nav-text">Relatórios</span>
        </a>
      </li>
    </ul>
  </nav>
</aside>
